import { render } from "./CrearTelefonoModal.vue?vue&type=template&id=72593777"
import script from "./CrearTelefonoModal.vue?vue&type=script&lang=js"
export * from "./CrearTelefonoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__